module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"text":"In Zusammenarbeit mit "},"en":{"text":"In association with "}}')
  delete Component.options._Ctor
}
